import dayjs, { Dayjs } from "dayjs"

export const WORKS_START = dayjs("2026-09-01T00:00:00")
export const WORKS_END = dayjs("2027-04-30T23:59:59")

export function rangeOverlapsWorks(start: Dayjs, end: Dayjs): boolean {
  return start.isBefore(WORKS_END) && end.isAfter(WORKS_START)
}
